import { Vendor } from '../../types/shared/Vendor';

// TODO: Move this out of shared and into frontend
export function trimFieldsForVendor(
  partialVendor: Partial<Vendor>,
): Partial<Vendor> {
  if (partialVendor.fields) {
    let trimmedVendorFields = partialVendor.fields.map((field) => {
      return typeof field.value === 'string'
        ? { ...field, value: field.value.trim() }
        : field;
    });
    return { ...partialVendor, fields: trimmedVendorFields };
  }
  return partialVendor;
}
